import Link from "../Link"
import React from "react"
import { withStyles } from "@material-ui/core/styles"

const styles = (theme) => ({
  headerLinkStyle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: theme.palette.common.white,
    transition: "color 0.2s ease-out",
    paddingLeft: 15,
    paddingRight: 15,
    fontWeight: 300,

    "&:hover": {
      color: theme.palette.secondary.main,
      textDecoration: "none",
    },

    [theme.breakpoints.down("xs")]: {
      paddingLeft: 8,
      paddingRight: 8,
    },

    [theme.breakpoints.only("sm")]: {
      paddingLeft: 10,
      paddingRight: 10,
    },

    [theme.breakpoints.up("lg")]: {
      paddingLeft: 20,
      paddingRight: 20,
      fontSize: 18,
    },
  },

  activeheaderLinkStyle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    //color: colors.white,
    transition: "color 0.2s ease-out",
    paddingLeft: 15,
    paddingRight: 15,
    fontWeight: 300,

    // active
    color: theme.palette.secondary.main,
    position: "relative",

    "&:hover": {
      color: theme.palette.secondary.main,
      textDecoration: "none",
    },

    [theme.breakpoints.down("xs")]: {
      paddingLeft: 8,
      paddingRight: 8,
    },

    [theme.breakpoints.only("sm")]: {
      paddingLeft: 10,
      paddingRight: 10,
    },

    [theme.breakpoints.up("lg")]: {
      paddingLeft: 20,
      paddingRight: 20,
      fontSize: 18,
    },
  },

  activeHeaderLinkAfterStyle: {
    position: "absolute",
    bottom: -1,
    height: 4,
    background: theme.palette.secondary.main,
    left: 0,
    right: 0,
    zIndex: 1,
  },
})

const HeaderLink = ({ isActive, title, to, classes }) => (
  <Link
    className={
      isActive ? classes.activeheaderLinkStyle : classes.headerLinkStyle
    }
    to={to}
  >
    {title}
    {isActive && <span className={classes.activeHeaderLinkAfterStyle} />}
  </Link>
)

export default withStyles(styles)(HeaderLink)
